import { useEffect } from "react";

export default function usePageMeta(title: string, description: string, keywords?: string) {
  useEffect(() => {
    document.title = title;

    const ensureMeta = (name: string, attr: "name" | "property" = "name") => {
      const selector = `meta[${attr}="${name}"]`;
      let element = document.head.querySelector(selector) as HTMLMetaElement | null;
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      return element;
    };

    ensureMeta("description").setAttribute("content", description);
    ensureMeta("og:title", "property").setAttribute("content", title);
    ensureMeta("og:description", "property").setAttribute("content", description);

    if (keywords) {
      ensureMeta("keywords").setAttribute("content", keywords);
    }
  }, [title, description, keywords]);
}